import Component from './modal.vue';
Vue.component(Component.name, Component);